export default __webpack_public_path__ + "static/media/zhongyangjiesuan.7f738e9f.png";